export const environment = {
    production: false,
    loginUrl: 'https://hfdvhshasvc1.vm.itg.corp.us.shldcorp.com:12243/HSSOMAuthService/services/auth/token?attributes=mail,title,cn,sn,shcdisplayname',
    apiUrl: 'https://hscam-campaign-manager-dev.stage.nextgen.shs.com/HSCCNCampaignManagerService'
  };